module.exports = __webpack_public_path__ + "img/img-ava.672703c9.png";